module.exports = __webpack_public_path__ + "img/booth3_home.cd6eabe6.jpg";